/**
 * Asynchronously loads the component for SessionExpiredPage
 */

import { lazyLoad } from 'utils/loadable';

export const SessionExpired = lazyLoad(
    () => import('./index'),
    (module) => module.SessionExpired,
);
